import * as types from './customerActionTypes';

export const getCustomerRequest = (payload) => 
({ type: types.GET_CUSTOMER_REQUEST, payload });
export const getCustomerSuccess = (payload) => 
({ type: types.GET_CUSTOMER_SUCCESS, payload });
export const getCustomerError = (payload) => 
({ type: types.GET_CUSTOMER_ERROR, payload });

export const addCustomerRequest = (payload) => 
({ type: types.ADD_CUSTOMER_REQUEST, payload });
export const addCustomerSuccess = (payload) => 
({ type: types.ADD_CUSTOMER_SUCCESS, payload });
export const addCustomerError = (payload) => 
({ type: types.ADD_CUSTOMER_ERROR, payload });

export const updateCustomerRequest = (payload) => 
({ type: types.UPDATE_CUSTOMER_REQUEST, payload });
export const updateCustomerSuccess = (payload) => 
({ type: types.UPDATE_CUSTOMER_SUCCESS, payload });
export const updateCustomerError = (payload) => 
({ type: types.UPDATE_CUSTOMER_ERROR, payload });

export const deleteCustomerRequest = (payload) => 
({ type: types.DELETE_CUSTOMER_REQUEST, payload });
export const deleteCustomerSuccess = (payload) => 
({ type: types.DELETE_CUSTOMER_SUCCESS, payload });
export const deleteCustomerError = (payload) => 
({ type: types.DELETE_CUSTOMER_ERROR, payload }); 